import { extend } from 'vee-validate';
import { validateEmail } from '../../utilities/emailValidation';
import { min, required, regex } from 'vee-validate/dist/rules';

extend('min', min);
extend('regex', regex);
extend('required', Object.assign(required, { message: '{_field_} is required.' }));

extend('name', {
	validate: value => {
		if (value.length < 1)
			return { valid: false, data: { reason: 'length' } };
		return true;
	},
	message: (field, values) => {
		return 'Your name can\'t be empty.';
	}
});

extend('unique', {
	params: ['value', 'values'],
	validate: (value, valuesObject) => {
		const loweredValues = valuesObject.values.map(v => v.toLowerCase());;
		if (loweredValues.includes(value.toLowerCase())) {
			return false;
		}
		return true;
	},
	message:
		'{_field_} must be unique.'
});

extend('email', {
	validate: value => validateEmail(value),
	message: 'Email must be formatted as name@domain.com.'
});

extend('string-length', (value, [minLength, maxLength]) => {
	if (value.length < minLength)
		return '{_field_} must be {0} characters or more.';
	if (value.length > maxLength)
		return '{_field_} must be {1} characters or less.';
	return true;
});
